import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Form, Formik } from "formik";
import * as Yup from "yup";

import PageStepsCard from "../components/Cards/PageStepsCard";
import PriceInformationCard from "../components/PriceInformationCard";
import ContactInputCard from "../components/Cards/ContactInputCard";

import history from "../router/history";
import { PageHeading } from "../components/PageHeading";
import { setCurrentStep, setStepAndContact } from "../reducers/stepsAction";
import { setHouseCompany } from '../reducers/simpleAction';
import { calculateAge } from '../helpers/helpers'

class ContactPage extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0);
    this.props.setCurrentStep(1);
  }

  render() {
    const mandatoryField = "Detta fält är obligatoriskt";

    this.props.setHouseCompany(this.props.match.params.id);
    
    let validLocations = this.props.textSections.validLocations;
    let validationErrorMessage = "Du måste bo i antingen " + validLocations.join(", ") + ".";
    let validationSchema = Yup.object().shape({
      firstName: Yup
        .string()
        .nullable()
        .required(mandatoryField),

      lastName: Yup
        .string()
        .required(mandatoryField),

      email: Yup
        .string()
        .email("Angiven e-post är inte giltig"),

      socialSecurityNumber: Yup.string()
        .matches(/^((19|20).)/, { message: "Måste vara född på 1900- eller 2000-talet.", })
        .matches(/^\d{12}$/, { message: "Personnummer måste innehålla 12 tecken." })
        .required(mandatoryField),
      streetAddress: Yup.string().required(mandatoryField),
      zipCode: Yup.string().required(mandatoryField),
      mailingAddress: Yup.string().trim()
        .test('test-0', validationErrorMessage, function(input) {
          let error = false;
          let validLocations = this.parent.textSections.validLocations;
          if(validLocations.length < 1) {
            return true;
          }

          if(input != undefined) {
            validLocations.map((value) => {
              if(error) { return error; }
              if (input.trim().toLowerCase().includes(value.toLowerCase())) {
                error = true;
              }
            })
          }
          return error;
        })
        .required(mandatoryField),
    });
    
    return (
      <div>
        <PageHeading title="Köp hemförsäkring" customer="true" preamble={this.props.preamble} history={this.props.history} />
        <div className="row">
          <div className="col-lg-8">
            <Formik
              enableReinitialize
              initialValues={{
                firstName: this.props.contact_information.first_name,
                lastName: this.props.contact_information.last_name,
                phone: this.props.contact_information.phone,
                email: this.props.contact_information.email,
                socialSecurityNumber: this.props.contact_information.social_security_number,
                streetAddress: this.props.contact_information.street_address,
                zipCode: this.props.contact_information.zip_code,
                mailingAddress: this.props.contact_information.mailing_address,
                municipality: this.props.contact_information.municipality,
                currentStreetAddress: this.props.contact_information.current_street_address,
                currentZipCode: this.props.contact_information.current_zip_code,
                currentMailingAddress: this.props.contact_information.current_mailing_address,
                personalTermsAccepted: this.props.personal_terms_accepted,
                textSections: this.props.textSections,
                confirmationEmail: this.props.contact_information.confirmationEmail
              }}
              validationSchema={validationSchema}
              onSubmit={fields => {
                this.props.setCurrentStep(2);
                this.props.history.push('/kund/' + this.props.match.params.id + '/apartment');
              }}
              >
                {(formikProps) =>
                  <Form>
                    <ContactInputCard {...formikProps} />
                    <PageStepsCard {...formikProps} />
                  </Form>
                }
             </Formik>
          </div>

          <div className="col-lg-4">
            <div className="sidebar">
              <PriceInformationCard />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    contact_information: state.contactReducer.contact_information,
    apartment_information: state.apartmentReducer.apartment_information,
    housingCompanyPath: state.simpleReducer.housingCompanyPath,
    currentStep: state.stepsReducer.currentStep,
    preamble: state.simpleReducer.textSections.preamble,
    textSections: state.simpleReducer.textSections
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setCurrentStep: bindActionCreators(setCurrentStep, dispatch),
    setStepAndContact: bindActionCreators(setStepAndContact, dispatch),
    setHouseCompany: bindActionCreators(setHouseCompany, dispatch)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ContactPage);
